import { render, staticRenderFns } from "./return-drawer.vue?vue&type=template&id=77da3bfc&"
import script from "./return-drawer.vue?vue&type=script&lang=js&"
export * from "./return-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports